export function isComponent(c, target) {
  return c.componentName === target.componentName;
}
